var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"quote"},[_c('h3',[_vm._v(" Your products + Our relationships = Rapid Sales Integration™ ")])])
}]

export { render, staticRenderFns }